/**
 * A utility for working with URLs
 */
export class UrlUtil {
  /**
   * Join the passed URL elements
   * @param urlElements - The URL elements to join
   * @returns The concatenated URL elements
   */
  public static join(...urlElements: string[]) {
    const resultArray = [];

    // If the first part is a plain protocol, we combine it with the next part.
    if (urlElements[0].match(/^[^/:]+:\/*$/) && urlElements.length > 1) {
      const first = urlElements.shift();
      urlElements[0] = first + urlElements[0];
    }

    // There must be two or three slashes in the file protocol, two slashes in anything else.
    if (urlElements[0].match(/^file:\/\/\//)) {
      urlElements[0] = urlElements[0].replace(/^([^/:]+):\/*/, '$1:///');
    } else {
      urlElements[0] = urlElements[0].replace(/^([^/:]+):\/*/, '$1://');
    }

    for (let i = 0; i < urlElements.length; i++) {
      let component = urlElements[i];

      if (typeof component !== 'string') {
        throw new TypeError('Url must be a string. Received ' + component);
      }

      if (component === '') {
        continue;
      }

      if (i > 0) {
        // Removing the starting slashes for each component but the first.
        component = component.replace(/^[\/]+/, '');
      }
      if (i < urlElements.length - 1) {
        // Removing the ending slashes for each component but the last.
        component = component.replace(/[\/]+$/, '');
      } else {
        // For the last component we will combine multiple slashes to a single one.
        component = component.replace(/[\/]+$/, '/');
      }

      resultArray.push(component);
    }

    let joinedString = resultArray.join('/');
    // Each input component is now separated by a single slash except the possible first plain protocol part.

    // remove trailing slash before parameters or hash
    joinedString = joinedString.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    const parts = joinedString.split('?');
    joinedString =
      parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');

    return joinedString;
  }
}
